import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

import {BehaviorSubject, Subject} from 'rxjs';

import * as fromModuleModels from '../../models';
import {filter, takeUntil} from 'rxjs/operators';
import {FormsService} from '../../../shared/services';
import {ErrorsObject} from '../../../shared/utilities/error-utility.utility';

@Component({
  selector: 'customer-cooperation-form',
  styleUrls: ['customer-cooperation-form.component.scss'],
  template: `

    <div class="card mat-elevation-z1">

      <div class="card__heading">
        <span>{{ presets$.getValue() ? 'Kooperation bearbeiten' : 'Neue Kooperation anlegen' }}</span>
      </div>

      <div class="card__content p-a--24">
        <div class="grid" [formGroup]="ccf">

          <mat-form-field class="column-14">
            <mat-label>Name</mat-label>
            <input type="text" matInput formControlName="name" required>
            <mat-hint align="start" *ngIf="errors?.name">{{ errors.name.message }}</mat-hint>
          </mat-form-field>
        </div>

        <div class="grid">
          <div class="m-ta--2 column-14">
            <button *ngIf="presets$.getValue() || ccf.dirty" class="m-r--16" (click)="cancelEdit()" type="button"
                    color="outline" mat-flat-button>
              <mat-icon class="m-r--8">cancel</mat-icon>
              <span>Abbrechen</span>
            </button>

            <button [disabled]="ccf.invalid || ccf.untouched" (click)="handleSubmit()" mat-flat-button color="green">
              <mat-icon class="m-r--8">save</mat-icon>
              <span>{{ presets$.getValue() ? 'Aktualisieren' : 'Anlegen' }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  `
})
export class CustomerCooperationFormComponent implements OnInit {

  @Input() errors: ErrorsObject;
  @Input() presets$: BehaviorSubject<fromModuleModels.Product>;

  @Output() requestCreateItem: EventEmitter<{ payload: fromModuleModels.Product, entity: string }> = new EventEmitter();
  @Output() requestUpdateItem: EventEmitter<{
    iri: string,
    payload: fromModuleModels.Product,
    entity: string
  }> = new EventEmitter();

  ccf: FormGroup;
  onDestroy$: Subject<any> = new Subject<any>();

  constructor(private fb: FormBuilder, private fs: FormsService) {
  }

  ngOnInit(): void {

    this.presets$.pipe(
      takeUntil(this.onDestroy$),
    ).subscribe(preset => {

      this.initForm();
      this.fs.patchForm(this.ccf, preset);
      this.ccf.markAsUntouched();
    });
  }

  initForm() {
    this.ccf = this.fb.group({
      name: this.fb.control(null, [Validators.required])
    });
  }

  cancelEdit() {
    this.initForm();
    this.presets$.next(null);
  }

  handleSubmit(): void {

    const payload: fromModuleModels.Product = this.ccf.value;

    !this.presets$.getValue()
      ? this.requestCreateItem.emit({payload, entity: 'CustomerCooperation'})
      : this.requestUpdateItem.emit({iri: this.presets$.getValue()['@id'], payload, entity: 'CustomerCooperation'});
  }
}
